import React from 'react';
import { FAQSectionOne } from './FAQSectionOne';
import { FAQSectionTwo } from './FAQSectionTwo';
import { FAQSectionThree } from './FAQSectionThree';

interface FAQSectionListProps {
  localizeMessage: (key: string) => string;
}

export const FAQSectionList: React.FC<FAQSectionListProps> = ({ localizeMessage }) => (
  <>
    <FAQSectionOne localizeMessage={localizeMessage} />
    <FAQSectionTwo localizeMessage={localizeMessage} />
    <FAQSectionThree localizeMessage={localizeMessage} />
  </>
);
